export const LESSON_LOCALES = ['ru', 'en'] as const;

export const DEFAULT_LESSON_LOCALE = 'ru';

export type LessonLocale = (typeof LESSON_LOCALES)[number];
